import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "ion-text-center ion-margin-top ion-padding"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px","margin":"0 auto"},
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "ion-margin-vertical" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"margin":"5px auto"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { id: "text-color-picker" }, null, -1)
const _hoisted_10 = { class: "horizontal-scroll" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { id: "product-color-picker" }, null, -1)
const _hoisted_12 = { class: "grey-bg color-buttons" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { style: {"font-size":"36px"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_group = _resolveComponent("v-group")!
  const _component_v_ellipse = _resolveComponent("v-ellipse")!
  const _component_v_transformer = _resolveComponent("v-transformer")!
  const _component_v_line = _resolveComponent("v-line")!
  const _component_v_circle = _resolveComponent("v-circle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            fixed: "",
            style: {"padding":"0"}
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leaveFilterMode()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.canvas.isFiltering]
              ]),
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetEraseImage()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.undo(_ctx.eraserHistory))),
                        disabled: _ctx.eraserHistory.step == -1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.arrowUndoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redo(_ctx.eraserHistory))),
                        disabled: _ctx.eraserHistory.states.length == 0 || _ctx.eraserHistory.step >= _ctx.eraserHistory.states.length-1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.arrowRedoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "success",
                        fill: "solid",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.completeEraseImage(_ctx.canvas.erasingShape)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('done')) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.checkmark
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.canvas.isErasing]
              ]),
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_button, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.leavePage()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !_ctx.canvas.selectedShape.id]
                      ]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCanvasSelectedShape({ id: '' })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.canvas.selectedShape.id]
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_ion_title, { style: {"padding-inline":"unset","padding-left":"8px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.getLocalizedStr(_ctx.product, 'title', 'titleEn')) + " " + _toDisplayString(_ctx.product.size), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.canvas.selectedShape.id]
                  ]),
                  _withDirectives(_createVNode(_component_ion_title, { style: {"padding-inline":"unset"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.canvas.selectedShape.text || _ctx.canvas.selectedShape.name || ''), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.canvas.selectedShape.id]
                  ]),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.undo(_ctx.appHistory))),
                        disabled: _ctx.appHistory.step == -1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.arrowUndoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redo(_ctx.appHistory))),
                        disabled: _ctx.appHistory.states.length == 0 || _ctx.appHistory.step >= _ctx.appHistory.states.length-1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.arrowRedoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeShape(_ctx.canvas.selectedShape.id, true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.trashOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.canvas.selectedShape.id]
                      ]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        shape: "round",
                        fill: "solid",
                        color: "success",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.leavePage(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('done')) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.checkmark
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !_ctx.canvas.selectedShape.id]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.canvas.isErasing && !_ctx.canvas.isFiltering]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              (_ctx.canvas.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('loadingAssets')), 1),
                    _createVNode(_component_ion_spinner)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      (!_ctx.canvas.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_segment, {
                                  mode: "ios",
                                  style: {"min-height":"40px","height":"40px"},
                                  modelValue: _ctx.dummy,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dummy) = $event)),
                                  onIonChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dummy = 'dummy')),
                                  scrollable: "",
                                  disabled: _ctx.canvas.isFiltering
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openTextPrompt())),
                                      layout: "icon-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('addText')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openNewCustomImagePrompt())),
                                      layout: "icon-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.cameraOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('addImage')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetProductDesign())),
                                      layout: "icon-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.refresh }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('resetDesign')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"]), [
                                  [_vShow, !_ctx.canvas.isErasing && !_ctx.canvas.selectedShape.id]
                                ]),
                                _withDirectives(_createVNode(_component_ion_segment, {
                                  mode: "ios",
                                  style: {"height":"48px"},
                                  modelValue: _ctx.dummy,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dummy) = $event)),
                                  onIonChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.dummy = 'dummy')),
                                  scrollable: "",
                                  disabled: _ctx.canvas.isErasing
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openStickerPreQuestionModal(_ctx.sticker.id, _ctx.canvas.selectedShape.id)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('editPetPhoto')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.canvas.isErasing || _ctx.isSelectingCustomImage()]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.startErasingImage())),
                                      class: _normalizeClass({ 'segment-button-checked' :_ctx.canvas.isErasing })
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.removeCircleOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('eraseImage')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["class"]), [
                                      [_vShow, _ctx.canvas.isErasing || _ctx.isSelectingCustomImage()]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openTextPrompt(_ctx.canvas.selectedShape)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('editText')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.isSelectingCustomText()]
                                    ]),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.flipSelectedShape())),
                                      disabled: _ctx.canvas.isFlipping
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.swapHorizontal }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('flip')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.moveSelectedShape('up')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.chevronUp }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('moveUp')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.moveSelectedShape('down')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.chevronDown }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('moveDown')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.duplicateSelectedShape()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.duplicateOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('duplicate')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"]), [
                                  [_vShow, _ctx.canvas.isErasing || _ctx.canvas.selectedShape.id]
                                ])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              class: "ion-margin-top",
                              style: _normalizeStyle([{"border":"1px solid grey","border-radius":"8px","margin":"0 auto"}, { width: `${_ctx.canvas.sceneWidth}px` }])
                            }, [
                              _withDirectives(_createVNode(_component_v_stage, {
                                ref: "filterStageRef",
                                config: { width: _ctx.canvas.sceneWidth, height: _ctx.canvas.sceneHeight }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_layer, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_image, {
                                        config: {
                      id: 'filteringImg',
                      x: 0,
                      y: 0,
                      scaleX: _ctx.canvas.filteringImg.scale,
                      scaleY: _ctx.canvas.filteringImg.scale,
                      image: _ctx.canvas.filteringImg.image,
                      pixelSize: _ctx.canvas.filteringImg.pixelSize,
                      levels: Math.abs(_ctx.canvas.filteringImg.levels),
                    }
                                      }, null, 8, ["config"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["config"]), [
                                [_vShow, _ctx.canvas.isFiltering]
                              ]),
                              _withDirectives(_createVNode(_component_v_stage, {
                                ref: "stageRef",
                                config: { width: _ctx.canvas.sceneWidth, height: _ctx.canvas.sceneHeight },
                                onMousedown: _ctx.handleStageMouseDown,
                                onTouchstart: _ctx.handleStageMouseDown,
                                onMousemove: _ctx.handleStageMouseMove,
                                onTouchmove: _ctx.handleStageMouseMove,
                                onMouseup: _ctx.handleStageTouchEnd,
                                onTouchend: _ctx.handleStageTouchEnd
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_layer, {
                                    config: { name: 'productLayer', visible: !_ctx.isCupProducts(_ctx.product) }
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.canvas.loadedProductImg)
                                        ? (_openBlock(), _createBlock(_component_v_image, {
                                            key: 0,
                                            config: {
                        id: 'productImg',
                        image: _ctx.canvas.loadedProductImg,
                        width: _ctx.canvas.productImgWidth,
                        height: _ctx.canvas.productImgHeight,
                        red: _ctx.canvas.productImgColor.red,
                        green: _ctx.canvas.productImgColor.green,
                        blue: _ctx.canvas.productImgColor.blue,
                        alpha: _ctx.canvas.productImgColor.alpha,
                      }
                                          }, null, 8, ["config"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, {
                                    config: {
                    name: 'designLayer',
                    listening: !_ctx.canvas.isErasing && !_ctx.canvas.isSelectingBackground,
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.canvas.backgroundImage)
                                        ? (_openBlock(), _createBlock(_component_v_rect, {
                                            key: 0,
                                            config: {
                        width: _ctx.canvas.sceneWidth,
                        height: _ctx.canvas.sceneHeight,
                        fillPatternImage: _ctx.canvas.backgroundImage,
                        fillPatternScaleX: _ctx.canvas.backgroundImageScale,
                        fillPatternScaleY: _ctx.canvas.backgroundImageScale,
                        fillPatternX: _ctx.canvas.backgroundImageX,
                        fillPatternY: _ctx.canvas.backgroundImageY,
                      }
                                          }, null, 8, ["config"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_group, {
                                        config: {
                      id: 'designShapes',
                      scaleX: _ctx.canvas.designLayerScale,
                      scaleY: _ctx.canvas.designLayerScale,
                      x: _ctx.canvas.designLayerX,
                      y: _ctx.canvas.designLayerY,
                    }
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.shapes.filter(s => !!s.id), (s) => {
                                            return (_openBlock(), _createBlock(_component_v_group, {
                                              key: s.id
                                            }, {
                                              default: _withCtx(() => [
                                                (s.type == 'text')
                                                  ? (_openBlock(), _createBlock(_component_v_text, {
                                                      key: 0,
                                                      onTransform: _ctx.handleTransform,
                                                      onTransformend: _ctx.handleTransformEnd,
                                                      config: {
                            lineHeight: s.lineHeight || 1,
                            type: s.type,
                            category: s.category || '',
                            id: s.id,
                            x: s.x,
                            y: s.y,
                            fill: s.color || 'rgb(0,0,0)',
                            text: s.text,
                            fontSize: 36,
                            scaleX: s.scaleX || 1,
                            scaleY: s.scaleY || 1,
                            align: 'center',
                            verticalAlign: 'middle',
                            fontFamily: s.fontFamily || _ctx.canvas.defaultFontFamily,
                            rotation: s.rotation,
                            visible: s.visible != false && _ctx.canvas.layerVisibility[s.materialId ? 'accessories' : s.type],
                            listening: (_ctx.canvas.lockMoveSelectedShape && s.id != _ctx.canvas.selectedShape.id) ? false : true,
                            draggable: _ctx.canvas.isPinching ? false : true,
                            stroke: s.strokeColor || _ctx.canvas.defaultStrokeColor,
                            strokeWidth: _ctx.isNumber(s.strokeWidth) ? s.strokeWidth : _ctx.canvas.defaultStrokeWidth,
                            fontStyle: s.fontStyle || '',
                            fillAfterStrokeEnabled: true,
                          }
                                                    }, null, 8, ["onTransform", "onTransformend", "config"]))
                                                  : (_openBlock(), _createBlock(_component_v_image, {
                                                      key: 1,
                                                      onTransform: _ctx.handleTransform,
                                                      onTransformend: _ctx.handleTransformEnd,
                                                      config: {
                            type: s.type,
                            category: s.category || '',
                            id: s.id,
                            width: s.width ? s.width : undefined,
                            height: s.height ? s.height : undefined,
                            x: s.x,
                            y: s.y,
                            rotation: s.rotation,
                            scaleX: s.scaleX || 1,
                            scaleY: s.scaleY || 1,
                            image: s.loadedImg,
                            name: s.name,
                            visible: _ctx.canvas.isErasing ? !!s.materialId : (s.visible != false && _ctx.canvas.layerVisibility[s.materialId ? 'accessories' : s.type]),
                            listening: (_ctx.canvas.lockMoveSelectedShape && s.id != _ctx.canvas.selectedShape.id) ? false : true,
                            draggable: _ctx.canvas.isPinching ? false : true,
                            brightness: s.brightness || 0,
                            blurRadius: s.blurRadius || 0,
                          }
                                                    }, null, 8, ["onTransform", "onTransformend", "config"]))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["config"]),
                                      (!_ctx.isCupProducts())
                                        ? (_openBlock(), _createBlock(_component_v_group, { key: 1 }, {
                                            default: _withCtx(() => [
                                              (_ctx.canvas.designAreaShape.radiusX > 0)
                                                ? (_openBlock(), _createBlock(_component_v_ellipse, {
                                                    key: 0,
                                                    config: {
                        x: _ctx.canvas.designAreaShape.x,
                        y: _ctx.canvas.designAreaShape.y,
                        radiusX: _ctx.canvas.designAreaShape.radiusX,
                        radiusY: _ctx.canvas.designAreaShape.radiusY,
                        fill: 'white',
                        listening: false,
                        globalCompositeOperation: 'destination-in',
                      }
                                                  }, null, 8, ["config"]))
                                                : (_openBlock(), _createBlock(_component_v_rect, {
                                                    key: 1,
                                                    config: {
                        x: _ctx.canvas.designAreaShape.x,
                        y: _ctx.canvas.designAreaShape.y,
                        width: _ctx.canvas.designAreaShape.width,
                        height: _ctx.canvas.designAreaShape.height,
                        fill: 'white',
                        listening: false,
                        globalCompositeOperation: 'destination-in',
                      }
                                                  }, null, 8, ["config"]))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_transformer, {
                                        ref: "transformer",
                                        onDragmove: _ctx.handleTrDragMove,
                                        onDragend: _ctx.handleTrDragEnd,
                                        config: {
                      keepRatio: true,
                      resizeEnabled: true,
                      rotationSnaps: [0, 90, 180, 270],
                      centeredScaling: false,
                      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                      anchorStrokeWidth: 3,
                      anchorCornerRadius: 20,
                      anchorSize: 20,
                      rotateAnchorOffset: 20,
                      useSingleNodeRotation: false,
                      flipEnabled: false,
                    }
                                      }, null, 8, ["onDragmove", "onDragend"])
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, {
                                    config: {
                    name: 'eraserLayer',
                    visible: _ctx.canvas.isErasing,
                    scaleX: _ctx.canvas.designLayerScale,
                    scaleY: _ctx.canvas.designLayerScale,
                    x: _ctx.canvas.designLayerX,
                    y: _ctx.canvas.designLayerY,
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_group, { config: {
                        name: 'erasedImgGroup',
                      } }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_image, {
                                            config: {
                          id: 'erasedImg',
                          width: _ctx.canvas.erasingShape.width,
                          height: _ctx.canvas.erasingShape.height,
                          x: _ctx.canvas.erasingShape.x,
                          y: _ctx.canvas.erasingShape.y,
                          rotation: _ctx.canvas.erasingShape.rotation,
                          scaleX: _ctx.canvas.erasingShape.scaleX,
                          scaleY: _ctx.canvas.erasingShape.scaleY,
                          image: _ctx.canvas.erasingShape.loadedImg,
                        }
                                          }, null, 8, ["config"]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.erasingLines, (line) => {
                                            return (_openBlock(), _createBlock(_component_v_line, {
                                              key: line.id,
                                              config: {
                        points: line.points,
                        stroke: 'red',
                        strokeWidth: line.strokeWidth,
                        lineCap: 'round',
                        lineJoin: 'round',
                        perfectDrawEnabled: false,
                        hitStrokeWidth: 0,
                        shadowForStrokeEnabled: false,
                        globalCompositeOperation: 'destination-out',
                      }
                                            }, null, 8, ["config"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_group, {
                                        config: {
                        id: 'eraserGroup',
                        x: (30-_ctx.canvas.designLayerX)/_ctx.canvas.designLayerScale,
                        y: (30-_ctx.canvas.designLayerY)/_ctx.canvas.designLayerScale,
                        draggable: true,
                      },
                                        onDragmove: _ctx.handleEraserDragMove,
                                        onDragend: _ctx.handleEraserDragEnd
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_circle, {
                                            config: {
                        x: 30,
                        y: 30,
                        radius: 5 / _ctx.canvas.designLayerScale,
                        stroke: 'white',
                        fill: 'red',
                        opacity: 0.8,
                        strokeWidth: 1 / _ctx.canvas.designLayerScale,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_circle, {
                                            config: {
                        x: 0,
                        y: 0,
                        radius: Math.max(_ctx.canvas.minEraserHelperRadius, _ctx.canvas.eraserRadius * 5),
                        fill: 'transparent',
                        perfectDrawEnabled: false,
                        shadowForStrokeEnabled: false,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_circle, {
                                            config: {
                        id: 'eraser',
                        x: 0,
                        y: 0,
                        radius: _ctx.canvas.eraserRadius,
                        stroke: 'black',
                        strokeWidth: 2 / _ctx.canvas.designLayerScale,
                      }
                                          }, null, 8, ["config"])
                                        ]),
                                        _: 1
                                      }, 8, ["config", "onDragmove", "onDragend"])
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, {
                                    config: {
                    name: 'designGridlinesLayer',
                    listening: false,
                    visible: !_ctx.canvas.isExporting,
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_group, {
                                        config: {
                      visible: _ctx.isCupProducts(_ctx.product)
                    }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_line, {
                                            config: {
                        points: [0, -6000, 0, 6000],
                        stroke: 'rgb(0, 161, 255)',
                        strokeWidth: 1,
                        dash: [4, 6],
                        x: _ctx.canvas.sceneWidth / 3,
                        y: 0,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_line, {
                                            config: {
                        points: [0, -6000, 0, 6000],
                        stroke: 'rgb(0, 161, 255)',
                        strokeWidth: 1,
                        dash: [4, 6],
                        x: (_ctx.canvas.sceneWidth / 3) * 2,
                        y: 0,
                      }
                                          }, null, 8, ["config"])
                                        ]),
                                        _: 1
                                      }, 8, ["config"]),
                                      _createVNode(_component_v_group, {
                                        config: {
                      visible: !_ctx.isCupProducts(_ctx.product)
                    }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_rect, {
                                            config: {
                        x: 0,
                        y: 0,
                        width: _ctx.canvas.productImgWidth,
                        height: _ctx.canvas.productImgHeight,
                        fill: 'black',
                        opacity: 0.05,
                      }
                                          }, null, 8, ["config"]),
                                          (_ctx.canvas.designAreaShape.radiusX > 0)
                                            ? (_openBlock(), _createBlock(_component_v_ellipse, {
                                                key: 0,
                                                config: {
                        x: _ctx.canvas.designAreaShape.x,
                        y: _ctx.canvas.designAreaShape.y,
                        radiusX: _ctx.canvas.designAreaShape.radiusX,
                        radiusY: _ctx.canvas.designAreaShape.radiusY,
                        stroke: 'rgb(0, 161, 255)',
                        dash: [4, 6],
                        fill: 'white',
                        globalCompositeOperation: 'destination-out',
                      }
                                              }, null, 8, ["config"]))
                                            : (_openBlock(), _createBlock(_component_v_rect, {
                                                key: 1,
                                                config: {
                        x: _ctx.canvas.designAreaShape.x,
                        y: _ctx.canvas.designAreaShape.y,
                        width: _ctx.canvas.designAreaShape.width,
                        height: _ctx.canvas.designAreaShape.height,
                        stroke: 'rgb(0, 161, 255)',
                        dash: [4, 6],
                        fill: 'white',
                        globalCompositeOperation: 'destination-out',
                      }
                                              }, null, 8, ["config"])),
                                          _createVNode(_component_v_line, {
                                            config: {
                        points: [0, -6000, 0, 6000],
                        stroke: 'rgb(0, 161, 255)',
                        strokeWidth: 1,
                        dash: [4, 6],
                        x: _ctx.getCenteredGridlinePoint('x'),
                        y: 0,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_line, {
                                            config: {
                        points: [-6000, 0, 6000, 0],
                        stroke: 'rgb(0, 161, 255)',
                        strokeWidth: 1,
                        dash: [4, 6],
                        x: 0,
                        y: _ctx.getCenteredGridlinePoint('y'),
                      }
                                          }, null, 8, ["config"])
                                        ]),
                                        _: 1
                                      }, 8, ["config"])
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, { config: {
                    name: 'lineGuideLayer'
                  } }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.lineGuides, (line, i) => {
                                        return (_openBlock(), _createBlock(_component_v_line, {
                                          key: i,
                                          config: {
                      points: line.points,
                      stroke: 'rgb(0, 161, 255)',
                      strokeWidth: 1,
                      name: 'guide-line',
                      dash: [4, 6],
                      x: line.x,
                      y: line.y
                    }
                                        }, null, 8, ["config"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["config", "onMousedown", "onTouchstart", "onMousemove", "onTouchmove", "onMouseup", "onTouchend"]), [
                                [_vShow, !_ctx.canvas.isFiltering]
                              ])
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.isCupProducts())
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "4",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openImageModal(_ctx.canvas.leftCupImg.previewPhotoLink)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.canvas.leftCupImg.previewPhotoLink
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        "size-xs": "4",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.openImageModal(_ctx.canvas.centerCupImg.previewPhotoLink)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.canvas.centerCupImg.previewPhotoLink
                          }, null, 8, _hoisted_6)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        "size-xs": "4",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.openImageModal(_ctx.canvas.rightCupImg.previewPhotoLink)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.canvas.rightCupImg.previewPhotoLink
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            id: "product_panel-modal",
            "is-open": true,
            "initial-breakpoint": 0.1,
            breakpoints: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6],
            "backdrop-dismiss": false,
            "backdrop-breakpoint": 1,
            "show-backdrop": false,
            "keep-contents-mounted": true,
            onDidPresent: _cache[59] || (_cache[59] = ($event: any) => (_ctx.onModalPresent()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "ion-no-padding" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.t('eraserSize')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_range, {
                            min: "2",
                            max: "30",
                            step: "1",
                            modelValue: _ctx.canvas.eraserRadius,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.canvas.eraserRadius) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { slot: "start" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('small')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_label, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('big')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.canvas.isErasing]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, { style: {"height":"36px","--min-height":"36px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, {
                            slot: "start",
                            style: {"height":"36px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setCanvasSelectedShape({ id: '' })))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_segment, {
                            mode: "ios",
                            modelValue: _ctx.canvas.targetImgAttr,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.canvas.targetImgAttr) = $event)),
                            scrollable: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_segment_button, {
                                value: "brightness",
                                layout: "icon-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('brightness')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_segment_button, {
                                value: "softEdges",
                                layout: "icon-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('softEdges')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_ion_range, {
                        mode: "ios",
                        pin: true,
                        "pin-formatter": (val) => `${parseFloat(val.toFixed(1))}`,
                        ticks: true,
                        snaps: true,
                        min: "-0.7",
                        max: "0.7",
                        step: "0.1",
                        modelValue: _ctx.canvas.selectedShape.brightness,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.canvas.selectedShape.brightness) = $event)),
                        onIonChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.addFiltersToSelectedShape()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('dimmer')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('brighter')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["pin-formatter", "modelValue"]), [
                        [_vShow, _ctx.canvas.targetImgAttr == 'brightness']
                      ]),
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "0",
                        max: "50",
                        step: "1",
                        modelValue: _ctx.canvas.selectedShape.blurRadius,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.canvas.selectedShape.blurRadius) = $event)),
                        onIonChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.addFiltersToSelectedShape()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("0")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode("50")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, _ctx.canvas.targetImgAttr == 'softEdges']
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.isSelectingCustomImage()]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "0.1",
                        max: "2",
                        step: "0.1",
                        modelValue: _ctx.canvas.backgroundImageScale,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.canvas.backgroundImageScale) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('small')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('big')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.canvas.isSelectingBackground]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "-0.03",
                        max: "0",
                        step: "0.005",
                        modelValue: _ctx.canvas.filteringImg.levels,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.canvas.filteringImg.levels) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('less')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('more')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, _ctx.canvas.selectedFilter == _ctx.photoFilters.posterize]
                      ]),
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        min: "3",
                        max: "10",
                        step: "0.5",
                        modelValue: _ctx.canvas.filteringImg.pixelSize,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.canvas.filteringImg.pixelSize) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('less')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('more')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, _ctx.canvas.selectedFilter == _ctx.photoFilters.pixelate]
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.canvas.isFiltering]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, { class: "ion-no-padding" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.setCanvasSelectedShape({ id: '' })))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                fill: "solid",
                                style: _normalizeStyle(`border: 1px solid lightgrey; --background: ${_ctx.canvas.selectedShape[_ctx.canvas.colorChangeTarget]}`)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("    ")
                                ]),
                                _: 1
                              }, 8, ["style"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            placeholder: _ctx.t('changeFontFamily'),
                            style: {"padding-right":"14px"},
                            modelValue: _ctx.canvas.selectedShape.fontFamily,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.canvas.selectedShape.fontFamily) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, {
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('changeFontFamily')), 1)
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.fontFamilyOptions, (fontFamily) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: fontFamily,
                                  value: fontFamily
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(fontFamily), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["placeholder", "modelValue"]),
                          _createVNode(_component_ion_chip, {
                            slot: "end",
                            outline: !((_ctx.canvas.selectedShape.fontStyle || '').includes('bold')),
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.toggleFontStyle('bold')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.t('bold')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"]),
                          _createVNode(_component_ion_chip, {
                            slot: "end",
                            outline: !((_ctx.canvas.selectedShape.fontStyle || '').includes('italic')),
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.toggleFontStyle('italic')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", null, _toDisplayString(_ctx.t('italic')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_ion_segment, {
                          mode: "ios",
                          modelValue: _ctx.canvas.colorChangeTarget,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.canvas.colorChangeTarget) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_segment_button, {
                              value: "color",
                              layout: "icon-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('textColor')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_segment_button, {
                              value: "strokeColor",
                              layout: "icon-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('strokeColor')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_toolbar, {
                          class: "ion-text-center grey-bg",
                          style: {"--min-height":"24px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings.defaultTextColorCodes, (color, i) => {
                              return (_openBlock(), _createBlock(_component_ion_button, {
                                key: i,
                                onClick: ($event: any) => (_ctx.changeTextColor(color)),
                                style: _normalizeStyle(`--background: ${color}; padding-right: 3px`),
                                size: "small",
                                shape: "round"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("   ")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "style"]))
                            }), 128)),
                            _createVNode(_component_ion_button, {
                              class: "more-color-btn",
                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.setPopoverOpen('textColor', true, $event))),
                              shape: "round",
                              fill: "clear",
                              size: "small",
                              style: {"--background":"transparent"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.add
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_popover, {
                          mode: "md",
                          isOpen: _ctx.popoverState.textColor,
                          event: _ctx.popoverEvent,
                          onDidDismiss: _cache[44] || (_cache[44] = ($event: any) => (_ctx.setPopoverOpen('textColor', false))),
                          dismissOnSelect: true,
                          showBackdrop: false,
                          keepContentsMounted: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_content, { class: "ion-padding" }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["isOpen", "event"]),
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.t('textStroke')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_range, {
                              min: "0",
                              max: "5",
                              step: "0.1",
                              modelValue: _ctx.canvas.selectedShape.strokeWidth,
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.canvas.selectedShape.strokeWidth) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('thin')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('thick')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.isSelectingCustomText()]
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      (_ctx.product.defaultColorCodes.length > 0)
                        ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                            key: 0,
                            class: "ion-text-center grey-bg",
                            style: {"padding-top":"12px","--min-height":"24px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "start",
                                class: "no-color-btn",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.changeProductColor(null))),
                                style: `--background: transparent; padding-right: 3px`,
                                size: "small",
                                shape: "round"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" \\ ")
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.imageColorCodes, (color, i) => {
                                  return (_openBlock(), _createBlock(_component_ion_button, {
                                    key: i,
                                    onClick: ($event: any) => (_ctx.changeProductColor(color)),
                                    style: _normalizeStyle(`--background: ${color}; padding-right: 3px`),
                                    size: "small",
                                    shape: "round"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("   ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "style"]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.recommendedColorCodes, (color, i) => {
                                  return (_openBlock(), _createBlock(_component_ion_button, {
                                    key: i,
                                    onClick: ($event: any) => (_ctx.changeProductColor(color)),
                                    style: _normalizeStyle(`--background: ${color}; padding-right: 3px`),
                                    size: "small",
                                    shape: "round"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("   ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "style"]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.defaultColorCodes, (color, i) => {
                                  return (_openBlock(), _createBlock(_component_ion_button, {
                                    key: i,
                                    onClick: ($event: any) => (_ctx.changeProductColor(color)),
                                    style: _normalizeStyle(`--background: ${color}; padding-right: 3px`),
                                    size: "small",
                                    shape: "round"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("   ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "style"]))
                                }), 128))
                              ]),
                              _createVNode(_component_ion_button, {
                                slot: "end",
                                class: "more-color-btn",
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.setPopoverOpen('productColor', true, $event))),
                                shape: "round",
                                fill: "clear",
                                size: "small",
                                style: {"--background":"transparent"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.add
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_toolbar, {
                            key: 1,
                            class: "grey-bg",
                            style: {"--min-height":"24px"}
                          }))
                    ]),
                    _createVNode(_component_ion_popover, {
                      mode: "md",
                      isOpen: _ctx.popoverState.productColor,
                      event: _ctx.popoverEvent,
                      onDidDismiss: _cache[48] || (_cache[48] = ($event: any) => (_ctx.setPopoverOpen('productColor', false))),
                      dismissOnSelect: true,
                      showBackdrop: false,
                      keepContentsMounted: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_content, { class: "ion-padding" }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["isOpen", "event"]),
                    _withDirectives(_createVNode(_component_ion_toolbar, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_buttons, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              class: "nav-category-btn",
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.navigateMaterialCategories('prev', '#product_panel-modal')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.chevronBack
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment, {
                          style: {"height":"48px"},
                          onIonChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onMaterialCategoryChanged())),
                          class: "sections",
                          modelValue: _ctx.canvas.selectedSectionTab,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.canvas.selectedSectionTab) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_segment_button, {
                              value: "已選",
                              style: {"--background":"var(--ion-color-primary)","--background-checked":"var(--ion-color-primary)","--color":"#000","--color-checked":"#fff"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('selected')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialCategories, (category) => {
                              return (_openBlock(), _createBlock(_component_ion_segment_button, {
                                key: category.id,
                                value: category.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getLocalizedStr(category, 'name', 'nameEn')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_buttons, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              class: "nav-category-btn",
                              onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.navigateMaterialCategories('next', '#product_panel-modal')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.chevronForward
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !_ctx.canvas.isFiltering]
                    ]),
                    _createVNode(_component_ion_popover, {
                      class: "color-popover",
                      "is-open": _ctx.isColorPopoverOpenRef,
                      event: _ctx.colorPopoverEvent,
                      showBackdrop: true,
                      side: "top",
                      onDidDismiss: _cache[53] || (_cache[53] = ($event: any) => (_ctx.isColorPopoverOpenRef = false)),
                      "dismiss-on-select": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.selectedPanelShape.colors, (color, i) => {
                            return (_openBlock(), _createBlock(_component_ion_button, {
                              key: i,
                              onClick: ($event: any) => (_ctx.addMaterialToCanvas(_ctx.canvas.selectedPanelShape, color)),
                              style: _normalizeStyle(`--background: ${color.colorHex}`),
                              size: "small",
                              shape: "round"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("   ")
                              ]),
                              _: 2
                            }, 1032, ["onClick", "style"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["is-open", "event"]),
                    _withDirectives(_createElementVNode("div", {
                      class: "material-div grey-bg",
                      onTouchmove: _cache[57] || (_cache[57] = (e) => e.stopPropagation())
                    }, [
                      _withDirectives(_createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_ctx.canvas.backgroundImage)
                            ? (_openBlock(), _createBlock(_component_ion_col, {
                                key: 0,
                                "size-xs": "3",
                                "size-lg": "2",
                                class: "ion-no-padding ion-text-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, {
                                    class: _normalizeClass(["material-card", { 'highlight-card': _ctx.canvas.isSelectingBackground }]),
                                    onClick: _cache[55] || (_cache[55] = ($event: any) => {_ctx.setCanvasSelectedShape({ id: '' }); _ctx.canvas.isSelectingBackground = true})
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_badge, {
                                        class: "top-left-badge normal-text",
                                        color: "danger",
                                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.clearCanvasBackground()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("img", {
                                        src: _ctx.canvas.backgroundImage.src
                                      }, null, 8, _hoisted_13)
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.panelShapes, (shape, i) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "3",
                              "size-lg": "2",
                              class: "ion-no-padding ion-text-center",
                              key: shape.id,
                              onClick: ($event: any) => (_ctx.setCanvasSelectedShape(shape, true, true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass(["material-card", { 'hidden-shape': !shape.visible, 'highlight-card': _ctx.canvas.selectedShape.id == shape.id }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_badge, {
                                      class: "top-left-badge normal-text",
                                      color: "medium"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(i+1), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("img", {
                                      src: _ctx.getShapeDataURL(_ctx.stageRef, shape)
                                    }, null, 8, _hoisted_14),
                                    _createVNode(_component_ion_text, { class: "material-text normal-text ion-text-nowrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(shape.text || shape.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.canvas.selectedSectionTab == '已選']
                      ]),
                      _withDirectives(_createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_col, {
                            "size-xs": "4",
                            "size-md": "3",
                            class: "ion-no-padding ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card, {
                                class: "material-card card-valign",
                                onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.clearCanvasBackground())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_text, { class: "material-text" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('transparentBackground')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.canvas.selectedSectionTab == 'background']
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (material) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "4",
                              "size-md": "3",
                              class: "ion-no-padding ion-text-center",
                              key: material.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass([{ 'highlight-card': _ctx.canvas.selectedPanelShape.id == material.id }, "material-card card-valign"]),
                                  onClick: ($event: any) => (_ctx.addMaterialToCanvas(material, null, $event)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    ((new Date().valueOf() - new Date(material.createdAt).valueOf()) / (1000*60*60*24) < 30)
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          style: {"letter-spacing":"normal"},
                                          class: "top-right-badge",
                                          color: "danger"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('new')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (material.photo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: material.photoLink
                                        }, null, 8, _hoisted_15))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createElementVNode("span", _hoisted_17, _toDisplayString(material.text), 1),
                                          _hoisted_18
                                        ])),
                                    _createVNode(_component_ion_text, { class: "material-text" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(material.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"])
                              ]),
                              _: 2
                            }, 1024)), [
                              [_vShow, material.category == _ctx.canvas.selectedSectionTab]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.canvas.selectedSectionTab != '已選']
                      ])
                    ], 544), [
                      [_vShow, !_ctx.canvas.isFiltering]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "material-div grey-bg",
                      onTouchmove: _cache[58] || (_cache[58] = (e) => e.stopPropagation())
                    }, [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.photoFilters), (filter) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "4",
                              "size-md": "3",
                              class: "ion-no-padding ion-text-center",
                              key: filter
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass(["material-card card-valign", { 'highlight-card': _ctx.canvas.selectedFilter == filter }]),
                                  onClick: ($event: any) => (_ctx.applyFilter(filter)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_text, { class: "material-text" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t(filter)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ], 544), [
                      [_vShow, _ctx.canvas.isFiltering]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}